import history from 'State/history';
import useMobileLayout from 'Hooks/useMobileLayout';
import { advisorMessagesPath } from 'Consts/Strings';

// PLEASE NOTE:
// This is a temporary hook until the advisor navigation is refactored to support mobile view
function usePathIsMobileFeed() {
  const isMobile = useMobileLayout();
  const isPathFeed = history.location.pathname === advisorMessagesPath;
  return isMobile && isPathFeed;
}

export default usePathIsMobileFeed;
